import * as React from 'react';
import * as ReactGA from 'react-ga';
import { useState } from 'react';
import { useLocation, Redirect, Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { Lens } from 'monocle-ts';
import { compose } from 'fp-ts/lib/function';
import { IProps, ILoginForm, IRegisterForm, IChangePassword } from './types';
import { withLocalState } from '../../../App/LocalState';
import { LoginBox } from './LoginBox';
import { RegisterBox } from './RegisterBox';
import { validateEmail } from '../../../Utilities/Validations';
import services from '../../../Api/services';
import loginBg from '../../../Assets/loginBG.jpg';
import keyframeLogo from '../../../Assets/Keyframe_Sports_Wordmark_Black.png';
import keyframeK from '../../../Assets/keyframe_logo.png';
import whiteLineBg from '../../../Assets/whiteLineBg.png';
import { Stack } from '@mui/material';
import { Button, TextField } from '@material-ui/core';
const styles = (theme: any) => ({
    loginRoot: {
        minHeight: '100vh',
        width: '100vw',
        position: 'fixed' as 'fixed',
        top: '0px',
        background: `url(${whiteLineBg}) center no-repeat fixed`,
        backgroundSize: 'cover',
    },
    overlay: {
        display: 'flex',
        flexDirection: 'column' as 'column',
        overflow: 'auto',
        position: 'fixed' as 'fixed',
        top: '0px',
        width: '100%',
        height: '100%',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative' as 'relative',
    },
    card: {
        top: '10vh',
        position: 'relative' as 'relative',
        background: '#FFFFFF',
        boxShadow: '0px 3px 12px #00000012',
        borderRadius: '20px',
        padding: '80px',
        [theme.breakpoints.down('lg')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '47px 72px',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '47px 32px',
        },
        textAlign: 'center' as 'center',
    },
    heading: {
        fonFamily: 'League Spartan',
        fontWeight: 500,
        fontSize: '32px',
        lineHeight: '38px',
        textTransform: 'uppercase' as 'uppercase',
        marginBotom: '56px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
        },
    },
    field: {
        width: '100%',
        marginTop: '20px',
        borderRadius: '0px',
        '& div': {
            borderRadius: '0px',
        },
        '& input': {
            background: '#fff',
            color: '#000',
            borderRadius: '0px',
        },
    },
    submitBtnWrapper: {
        textAlign: 'center' as 'center',
    },
    submitBtn: {
        fontWeight: 500,
        background: '#EF0017',
        textTransform: 'none' as 'none',
        borderRadius: '24px',
        color: 'white',
        fontSize: '14px',
        lineHeight: '18px',
        padding: '12px 24px',
        width: '175px',
        boxSize: 'borderBox',
        height: '48px',
        [theme.breakpoints.down('xs')]: {
            height: '32px',
            padding: '8px 16px',
            width: '200px',
        },
        '&:disabled': {
            background: '#cccccc',
            color: '#666666',
        },
    },
    errors: {
        border: '3px solid red',
    },
    message: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '14px',
        lineHeight: '18px',
        marginTop: '16px',
    },
    messageBox: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '14px',
        lineHeight: '18px',
        marginTop: '24px',
        maxWidth: '380px',
    },
    resetPassword: {
        padding: '10px 0px',
        textAlign: 'center' as 'center',
        fontSize: '14px',
        lineHeight: '18px',
    },
    link: {
        color: '#EF0017',
        paddingLeft: '4px',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    textField: {
        width: '100%',
        display: 'flex',
        aligItems: 'flex-start',
        flexDirection: 'column' as 'column',
        marginBottom: '40px',
        '&:last-child': {
            marginBottom: '0px',
        },
    },

    labelField: {
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left' as 'left',
        fontWeight: 500,
    },
    inputField: {
        border: 'none',
        borderBottom: '1px solid black',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    inputFieldError: {
        border: 'none',
        borderBottom: '1px solid red',
        padding: '16px 4px',
        marginTop: '4px',
        background: 'white',
        outline: 'none',
    },
    formWrapper: {
        marginTop: '24px',
        padding: '0px 25px',
    },
    erroSpan: {
        textAlign: 'left' as 'left',
        color: 'red',
        fontSize: '12px',
        margin: '8px',
    },
    successSpan: {
        textAlign: 'left' as 'left',
        color: 'green',
        fontSize: '12px',
        margin: '8px',
    },
    footer: {
        marginTop: '50px',
        marginBottom: '15px',
        position: 'absolute' as 'absolute',
        bottom: '0px',
        left: '40%',
        right: '40%',
        [theme.breakpoints.down('md')]: {
            left: '40%',
            right: '40%',
        },
        [theme.breakpoints.down('sm')]: {
            left: '30%',
            right: '30%',
        },
        [theme.breakpoints.down('xs')]: {
            left: '20%',
            right: '20%',
        },
        fontSize: '12px',
        textAlign: 'center' as 'center',
    },
});

const search = window.location.search;
const params = new URLSearchParams(search);

const defaultResetPasswordState: IChangePassword = {
    newPassword: '',
    confirmPassword: '',
    newPasswordTouched: false,
    matched: false,
    confirmPasswordTouched: false,
};

const statusList = [422, 409, 200, 404, 401]

const forgotPassword = (props: IProps) => {
    const { classes, history } = props;
    const [resetPasswordState, updateResetPasswordState]: [
        IChangePassword,
        (state: IChangePassword) => any
    ] = useState(defaultResetPasswordState);

    const { pathname } = useLocation();

    const errorChangingPassword = `There was an error changing your password. Email info@keyframesports.com for help.`
    const [passwordChanged, setPasswordChanged]: any = React.useState(false);
    const [error, setError]: any = React.useState();
    const [success, setSuccess]: any = React.useState();
    const [submitting, setSubmitting]: any = React.useState(false);

    const handlePasswordChange = (
        value: string,
        name: 'newPassword' | 'confirmPassword'
    ) => {
        updateResetPasswordState({
            ...resetPasswordState,
            [name]: value,
        });
    };

    const changePassword = async () => {
        const body = {
            password: resetPasswordState.newPassword,
            token: params.get('token')
        };
        const url = process.env.REACT_APP_ALEPH_URI +
            '/api-v1/authentication/password-reset/change';
        setSubmitting(true);
        const res = await fetch(url, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        const status = await res.status;
        if (status === statusList[2]) {
            setSubmitting(false);
            setPasswordChanged(true);
            setSuccess('Password has been changed, please go back to login');
        } else {
            setSubmitting(false);
            setError(errorChangingPassword);
        }
    };

    const disableButton =
        !resetPasswordState.newPassword ||
        !resetPasswordState.confirmPassword ||
        resetPasswordState.newPassword !== resetPasswordState.confirmPassword;

    const handleNewPasswordInputFocus = (
        name: 'newPasswordTouched' | 'confirmPasswordTouched'
    ) => {
        updateResetPasswordState({
            ...resetPasswordState,
            [name]: true,
        });
    };

    React.useEffect(() => {
        if (resetPasswordState.newPassword.length === 0) {
            updateResetPasswordState({
                ...resetPasswordState,
                confirmPasswordTouched: false,
            });
        }
    }, [resetPasswordState.newPassword]);

    return (
        <div className={classes.loginRoot}>
            <div className={classes.overlay}>
                <div className={classes.content}>
                <div className={classes.card}>
                    <div className={classes.heading} >
                        CHANGE PASSWORD
                    </div>

                    <form className={classes.formWrapper}>
                    <div className={classes.textField}>

                    <div className={classes.labelField}>Password</div>
                    <input
                        className={
                            error
                                ? classes.inputFieldError
                                : classes.inputField
                        }
                        required
                        id='newPassword'
                        onChange={(e) =>
                            handlePasswordChange(e.target.value, 'newPassword')
                        }
                        value={resetPasswordState.newPassword}
                        onFocus={() =>
                            handleNewPasswordInputFocus('newPasswordTouched')
                        }
                        placeholder='Password *'
                        type='password'
                    />
                    </div>
                    <div className={classes.textField}>
                    <div className={classes.labelField}>Confirm Password</div>
                    <input
                        className={
                            error
                                ? classes.inputFieldError
                                : classes.inputField
                        }
                        required
                        id='confirmPassword'
                        onFocus={() =>
                            handleNewPasswordInputFocus(
                                'confirmPasswordTouched'
                            )
                        }
                        onChange={(e) =>
                            handlePasswordChange(
                                e.target.value,
                                'confirmPassword'
                            )
                        }
                        value={resetPasswordState.confirmPassword}
                        placeholder='Confirm password'
                        type='password'
                    />

                        <span className={classes.erroSpan}>
                            {error ? error : null}
                        </span>

                        <span className={classes.successSpan}>
                            {success ? success : null}
                        </span>
                    </div>

                    <div className={classes.submitBtnWrapper}>
                    <Button
                        disabled={disableButton}
                        variant='contained'
                        color='primary'
                        onClick={() => changePassword()}
                        fullWidth
                        className={classes.submitBtn}
                    >
                        Change Password
                    </Button>
                    </div>

                    <div className={classes.message}>
                        <span>Go back to </span>{' '}
                        <Link to='/login' className={classes.link}>
                            Sign in{' '}
                        </Link>
                    </div>
                    </form>
                </div>
                </div>
            </div>
        </div>
    );
};

export const ChangePassword = compose(
    withStyles(styles),
    withLocalState
)(forgotPassword);
